import AccountsReviewable from './TransitionForms/AccountsReviewable';
import BenefitsView from './TransitionForms/Benefits/BenefitsView';
import BusinessDevelopmentView from './TransitionForms/BusinessDevelopment/BusinessDevelopmentView';
import ClinicalView from './TransitionForms/Clinical/ClinicalView';
import ClinicalReimbursementView from './TransitionForms/ClinicalReimbursement/ClinicalReimbursementView';
import DietaryView from './TransitionForms/Dietary/DietaryView';
import EnvironmentalView from './TransitionForms/Environmental/EnvironmentalView';
import FacilityInformationView from './TransitionForms/FacilityInformationView';
import HRView from './TransitionForms/HR/HRView';
import OperationsView from './TransitionForms/Operations/OperationsView';
import PayrollView from './TransitionForms/Payroll/PayrollView';
import PharmacyView from './TransitionForms/Pharmacy/PharmacyView';
import PlantOperationsView from './TransitionForms/PlantOperations/PlantOperationsView';
import ReportsView from './TransitionForms/Reports/ReportsView';
import TelecommunicationsView from './TransitionForms/Telecommunications/TelecommunicationsView';
import TransportationView from './TransitionForms/Transportation/TransportationView';
import VendorsView from './TransitionForms/Vendors/VendorsView';

export const formComponentMap = {
  3: FacilityInformationView,
  4: DietaryView,
  5: BusinessDevelopmentView,
  6: OperationsView,
  7: ClinicalReimbursementView,
  8: PlantOperationsView,
  9: PayrollView,
  10: TelecommunicationsView,
  11: HRView,
  12: EnvironmentalView,
  13: VendorsView,
  14: ReportsView,
  15: TransportationView,
  16: ClinicalView,
  17: BenefitsView,
  18: PharmacyView,
  19: AccountsReviewable,
};
